<template>
  <div class="stamp-duty-confirm-transfer" style="width: 100vw">
    <div class="column">
      <b-field
        :label="`${$t('sale_value')}（${$t('mop')}） :`"
        :message="$t(validation.firstError('saleValue'))"
      >
        <p class="control">
          <b-button>MOP</b-button>
        </p>
        <b-input
          v-model="saleValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('house_record_value')} :`"
        :message="$t(validation.firstError('houseRecordValue'))"
      >
        <p class="control">
          <b-button>MOP</b-button>
        </p>
        <b-input
          v-model="houseRecordValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div v-if="isShowResult" class="column">
      <b-table
        :data="this.tableDataOne"
        :columns="columns"
        :bordered="true"
        :hoverable="true"
        :striped="true"
      >
        <template #footer>
          <div class="column has-text-centered">
            {{ $t("calculate_transfer_stamp_duty_from_one_year") }}
          </div>
        </template>
      </b-table>
    </div>

    <br />

    <div v-if="isShowResult" class="column">
      <b-table
        :data="this.tableDataTwo"
        :columns="columns"
        :bordered="true"
        :hoverable="true"
        :striped="true"
      >
        <template #footer>
          <div class="column has-text-centered">
            {{ $t("calculate_transfer_stamp_duty_from_two_year") }}
          </div>
        </template>
      </b-table>
    </div>

    <div v-if="isShowResult" class="column is-full">
      1) {{ $t("remark_1") }}
    </div>

    <div v-if="isShowResult" class="column is-full">
      2) {{ $t("remark_2") }}
    </div>

    <div class="column">
      <b-button
        @click="calculate"
        class="is-primary"
        style="background-color: #00775e"
      >
        {{ $t("calculate") }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saleValue: "",
      houseRecordValue: "",
      tableDataOne: "",
      tableDataTwo: "",
      isShowResult: false,
      columns: [
        {
          field: "tax_rate",
          label: this.$t("tax_rate"),
          centered: true,
        },
        {
          field: "tax_amt",
          label: this.$t("tax_amt"),
          numeric: true,
        },
        {
          field: "total_tax_amt",
          label: this.$t("total_tax_amt"),
          numeric: true,
        },
      ],
    };
  },

  validators: {
    saleValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .integer();
    },

    houseRecordValue: function(value) {
      return this.$validator()
        .value(value)
        .integer();
    },
  },

  computed: {
    propertyValue() {
      const saleValueInt = parseInt(this.saleValue);

      const houseRecordValueInt = this.houseRecordValue
        ? parseInt(this.houseRecordValue)
        : 0;

      if (saleValueInt > houseRecordValueInt) {
        return this.saleValue;
      }

      return this.houseRecordValue;
    },
  },

  methods: {
    calculate() {
      const value = this.propertyValue;

      this.tableDataOne = [
        {
          tax_rate: "20%",
          tax_amt: this.$options.filters.formatNumberWithoutPoint(value),
          total_tax_amt: this.$options.filters.formatNumberWithoutPoint(
            this.totalTaxAmt(0.2)
          ),
        },
      ];

      this.tableDataTwo = [
        {
          tax_rate: "10%",
          tax_amt: this.$options.filters.formatNumberWithoutPoint(value),
          total_tax_amt: this.$options.filters.formatNumberWithoutPoint(
            this.totalTaxAmt(0.1)
          ),
        },
      ];

      this.$validate().then((success) => {
        if (success) {
          this.isShowResult = true;
        }
      });
    },

    totalTaxAmt(tax_rate) {
      const value = this.propertyValue;
      return value * tax_rate;
    },
  },
};
</script>
